import * as React from 'react'
import { cn } from '../../lib/utils'

export type LogoSize = 'sm' | 'md' | 'lg' | 'xl'

export interface LogoProps {
  size?: LogoSize
  showText?: boolean
  className?: string
  /** Override the default logo image. Pass an imported image or URL. */
  src?: string
}

const sizeMap: Record<LogoSize, { container: string; text: string; brandText: string }> = {
  sm: { container: 'w-8 h-8 rounded-lg', text: 'text-sm', brandText: 'text-base' },
  md: { container: 'w-10 h-10 rounded-xl', text: 'text-lg', brandText: 'text-lg' },
  lg: { container: 'w-14 h-14 rounded-2xl', text: 'text-2xl', brandText: 'text-xl' },
  xl: { container: 'w-18 h-18 rounded-2xl', text: 'text-3xl', brandText: 'text-2xl' },
}

export function Logo({ size = 'md', showText = false, className, src }: LogoProps) {
  const s = sizeMap[size]

  return (
    <div className={cn('flex items-center gap-3', className)}>
      {src ? (
        <img
          src={src}
          alt="IntelliMon"
          className={cn(s.container, 'object-contain')}
        />
      ) : (
        <div
          className={cn(
            s.container,
            'bg-gradient-primary flex items-center justify-center shadow-industrial shrink-0'
          )}
        >
          <span className={cn(s.text, 'font-bold text-white tracking-tight')}>IM</span>
        </div>
      )}
      {showText && (
        <span className={cn(s.brandText, 'font-semibold tracking-tight')}>IntelliMon</span>
      )}
    </div>
  )
}
